// @flow
import styled from 'styled-components'
import { Layout, Card } from 'antd'
const { Content } = Layout

export const StyledSubscriptionCard = styled(Card)`
    margin-bottom: 50px !important;
    
`

export const StyledPaymentCard = styled(Card)`
    margin-bottom: 50px !important;
    
    .ant-card-body {
      padding: 0 !important;
    }
    
    .failed {
     background-color: #f97777 !important;
    }
`

export const StyledCard = styled(Card)`
    min-height: 60vh;
    
    .alert-phone {
      .ant-input-affix-wrapper .ant-input:not(:first-child) {
        padding-left: 38px;
      }
    }
    
   .flag-select {
      width: 100%;
      height: 32px;
      border: 1px solid #d9d9d9;
      border-radius: 4px;
      transition: all .3s;
       
      .flag-options {
        width: 100%;
      }
      .arrow-down {
        float: right;
      }
      .selected--flag--option {
        font-size: 14px;
        height: 32px;
        padding: 0;
        padding-top: 3px;
        .country-label {
          font-size: 14px !important;
        }
        
      }
      .flag-options {
        margin-top: 0;
      }
      .country-flag {
          img {
            top: -1px;
            left: 5px;
          }
      }
      .filterBox {
         margin: 10px 0;
         input {
              width: 90%;
              margin: 0 4%;
              border: solid 1px #eee;
              padding: 5px;
         }
      }
   }
`

export const StyledContent = styled(Content)`
  background: #fff;
  margin: 24px 16px;
  min-height: 280px;
  padding: 0;
  
 .title {
    font-size: 23px;
    margin-top: 10px;
 }
 
 .tabs {
    border-bottom: 2px solid #eee;
   .section {
      max-width: 600px;
      padding: 15px 0;
   }
   .trade-plan {
     .ant-row {
        margin-top: 15px;
     }
   }
 }
 
 .ant-col-24 {
  padding: 10px 0;
 }
 
 input[type=text] {
  width: 190px;
 }
  
  .summary {
    max-width: 500px;
    > div {
      display: flex;
      div {
        flex: 1;
      }
      div:first-child {
        flex: 2;
      }
   }

  
`

export const StyledCapital = styled.span`
  text-transform: uppercase;
`





// WEBPACK FOOTER //
// ./src/components/user-profile/style.js